import { defineComponent, ref, watch } from "vue";
import { definePropType } from "@types-vue/props";
import { fmtSize } from "@com/utils/data-format";
import { format } from "date-fns";
import handleClipboard from "@/utils/clipboard";
import ShowTipContent from "@com/components/show-tips-content/index.vue";
import AssetCard from "@com/components/asset-card/index.vue";
import { coverImg } from "@pt/views/pt-entry/creative-assets/media/resource-module";
import { AssetStatus } from "@pt/enums/assets";
export default defineComponent({
    props: {
        loading: {
            type: definePropType(Boolean),
            default: false
        },
        list: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        multipleSelection: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        rules: {
            type: definePropType(Object)
        },
        // 禁用全部checkbox,因为编辑器项目的的资产库需要支持禁用除选中项以外的全部素材
        disabledCheckbox: {
            type: definePropType(Boolean),
            default: false
        },
        // checkbox按钮是否常驻
        showCheckbox: {
            type: definePropType(Boolean),
            default: false
        },
        // 禁止选中的ID集合
        disabledSelectId: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        // 是否启用跨域
        crossorigin: {
            type: Boolean,
            default: false
        }
    },
    components: {
        ShowTipContent: ShowTipContent,
        AssetCard: AssetCard
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var getDirection = function getDirection(item) {
            if (item.width / item.height > 1) {
                return 1;
            } else if (item.width / item.height < 1) {
                return 2;
            }
            return 3;
        };
        var checkboxShow = function checkboxShow(status) {
            return status !== AssetStatus.Transcoding && status !== AssetStatus.Pending && status !== AssetStatus.Error;
        };
        var handleShowCheckbox = function handleShowCheckbox(status) {
            if (props.showCheckbox) {
                return status !== AssetStatus.Transcoding && status !== AssetStatus.Pending;
            }
            return false;
        };
        var cardMultipleSelection = ref([]);
        watch(function() {
            return props.multipleSelection;
        }, function(val) {
            cardMultipleSelection.value = val;
        }, {
            immediate: true
        });
        var isChecked = function(id) {
            return cardMultipleSelection.value.some(function(item) {
                return item.id === id;
            });
        };
        var isDisabled = function(item, rules) {
            if (typeof rules === "undefined") return false;
            var rule = rules[item.creative_type];
            if (typeof rule === "undefined") return true;
            if (typeof rule.size_max !== "undefined" && rule.size_max < item.file_size) {
                return true;
            }
            if (typeof rule.formats !== "undefined" && rule.formats.indexOf(item.format) === -1) {
                return true;
            }
            if (props.disabledSelectId.length && props.disabledSelectId.indexOf(item.id) > -1) {
                return true;
            }
            if (typeof rule.frames !== "undefined" && item.creative_type === "seqframe" && item.payload && JSON.parse(item.payload).frames < rule.frames) {
                return true;
            }
            if (typeof rule.duration_max !== "undefined" && rule.duration_max < item.duration) {
                return true;
            }
            if (typeof rule.directions !== "undefined" && rule.directions.length && rule.directions.indexOf(getDirection(item)) === -1) {
                return true;
            }
            if (typeof rule.count !== "undefined" && cardMultipleSelection.value.length >= rule.count && !isChecked(item.id)) {
                return true;
            }
            return false;
        };
        var isAllDisabled = function(id) {
            if (props.disabledCheckbox) {
                return !cardMultipleSelection.value.some(function(item) {
                    return item.id === id;
                });
            }
            return false;
        };
        var handleCheckConfig = function(item) {
            var index = cardMultipleSelection.value.findIndex(function(val) {
                return val.id === item.id;
            });
            if (index !== -1) {
                cardMultipleSelection.value.splice(index, 1);
            } else {
                cardMultipleSelection.value.push(item);
            }
            emit("handleSelection", cardMultipleSelection.value);
        };
        var handleCheckLi = function(item) {
            if (props.disabledSelectId.includes(item.id)) return;
            if (item.status !== AssetStatus.Transcoding && item.status !== AssetStatus.Pending && item.status !== AssetStatus.Error) {
                handleCheckConfig(item);
            }
        };
        var jumpDetail = function(index, status) {
            if (status !== AssetStatus.Transcoding && status !== AssetStatus.Pending && status !== AssetStatus.Error) {
                emit("jumpDetail", index);
            }
        };
        // 转码失败重试
        var retryEvent = function(id) {
            emit("retry", id);
        };
        return {
            AssetStatus: AssetStatus,
            handleClipboard: handleClipboard,
            fmtSize: fmtSize,
            format: format,
            isChecked: isChecked,
            isAllDisabled: isAllDisabled,
            isDisabled: isDisabled,
            handleCheckConfig: handleCheckConfig,
            jumpDetail: jumpDetail,
            coverImg: coverImg,
            handleCheckLi: handleCheckLi,
            checkboxShow: checkboxShow,
            retryEvent: retryEvent,
            handleShowCheckbox: handleShowCheckbox
        };
    }
});
